import { createStripePayment } from "API/StripeAPI";
import React from "react";
import { withTranslation } from "react-i18next";
import { FaInfoCircle } from "react-icons/fa";
import { IoIosCard } from "react-icons/io";
import ReactTable from "react-table";
import { Button, CardBody, Col, FormGroup, Input, Label, Row, Spinner, Tooltip } from "reactstrap";

class ScannerBuyContent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      tooltipOpen: false,
      quantity: 0,
      price: '$ 0.00',
    };
    this.tooltipId = `Tooltip-${Math.random().toString(36).substr(2, 9)}`; // Generate a unique ID for each tooltip
    this.handleQuantityChange = this.handleQuantityChange.bind(this);
  }

  toggleTooltip = () => {
    this.setState((prevState) => ({
      tooltipOpen: !prevState.tooltipOpen,
    }));
  };

  handleQuantityChange(event) {
    const value = event.target.value;
    const obj = this.props.optionsList.filter(item => {
        const [start, end] = item.bracket;
        if (item.bracket.length === 2) {
            return value >= start && value <= end;
        } else {
            return value >= start;
        }
    });
    const price = obj.length > 0 ? obj[0].priceInCents * value / 100 : 0;
    this.setState({ 
      quantity: value,
      price: '$ ' + Number(price).toFixed(2)
    });
  }

  async buy(plan, quantity = 0) {
    const params = { productId: plan.id };
    if (quantity > 0) {
      params.quantity = Number(quantity);
    }
    const response = await createStripePayment(params);

    if (response.ok) {
      window.open(response.url, "_blank").focus();
    } else {
      alert("Error processing payment.");
    }
  }

  render() {
    const {
      title,
      subTitle,
      product,
      tooltip,
      buyText,
      optionsList,
      mostPopular,
      selectQuantity
    } = this.props;
    const { t, i18n } = this.props;

    const quantitySelector = (
      <Row>
        <Col md={1}>
          <Label for="quantity">{t('phish_guard_url_checker.buy.quantity')}</Label>
        </Col>
        <Col md={3}>
          <Input type="number" step="1" min="0" name="quantity" id="quantity"
          value={this.state.quantity} onChange={this.handleQuantityChange} />
        </Col>
        <Col md={1}>
          <Label for="price">{t('phish_guard_url_checker.buy.price')}</Label>
        </Col>
        <Col md={3}>
          <Input type="text" name="price" id="price" value={this.state.price} redonly />
        </Col>
        <Col md={3}>
          <Button color="primary" onClick={() => this.buy(optionsList[0], this.state.quantity)}
            disabled={this.state.quantity < 1} >
            <span className="d-flex align-items-center" style={{ gap: "0.5rem" }}>
              <IoIosCard />
              {buyText}
            </span>
          </Button>
        </Col>
      </Row>
    );

    return (
      <div className="bg-white rounded shadow-sm">
        <CardBody className="position-relative overflow-hidden">
          <div>
            <div
              className="d-flex align-items-center"
              style={{ gap: "0.5rem" }}
            >
              <h2>{title}</h2>
              <FaInfoCircle id={this.tooltipId} className="text-lg" />
              <Tooltip
                isOpen={this.state.tooltipOpen}
                target={this.tooltipId}
                toggle={this.toggleTooltip}
              >
                {tooltip}
              </Tooltip>
            </div>
            <span className="text-muted">{subTitle}</span>
            {mostPopular && (
              <div
                className="position-absolute"
                style={{
                  top: "2rem",
                  right: "-2rem",
                  width: "150px",
                  transform: "rotate(45deg)",
                  background: "#28a745",
                  color: "white",
                  textAlign: "center",
                  fontSize: "10px",
                  fontWeight: "bold",
                  padding: "3px 0",
                }}
              >
                {mostPopular}
              </div>
            )}
          </div>
          {selectQuantity ? (
            <div>{quantitySelector}</div>
          ) : null}
          {optionsList.length > 0 ? (
            <ReactTable
              columns={[
                {
                  id: "queries",
                  Cell: (row) => (
                    <div className="flex-fill text-center">
                      {selectQuantity ? "[" + row.original.bracket.join(", ") + "]" : row.original.queriesPerDay}
                    </div>
                  ),
                },
                {
                  id: "product",
                  Cell: (row) => (
                    <div className="flex-fill text-center">
                      {product}
                    </div>
                  ),
                },
                {
                  id: "price",
                  Cell: (row) => (
                    <div className="flex-fill text-center">
                      {'$ ' + Number(row.original.priceInCents / 100).toFixed(2)}
                    </div>
                  ),
                },
                {
                  id: "action",
                  Cell: (row) => (
                    <div className="flex-fill text-center">
                      <Button color="primary" onClick={() => this.buy(row.original)}>
                        <span className="d-flex align-items-center" style={{ gap: "0.5rem" }}>
                          <IoIosCard />
                          {buyText}
                        </span>
                      </Button> 
                    </div>
                  ),
                  show: !selectQuantity,
                },
              ]}
              data={optionsList}
              showPagination={false}
              pageSize={optionsList.length}
              className="-striped -highlight my-4 borderless-table"
              TheadComponent={() => null} // Hides the table header
            />
          ) : (
            <Spinner className="my-4" color="primary" />
          )}
        </CardBody>
      </div>
    );
  }
}

export default withTranslation()(ScannerBuyContent);
